import React, {useEffect} from 'react';
import {Box} from "@mui/material";
import {useLanguage} from "../../LanguageContext";
import BackButton from "../../components/tours/BackButton";
import ReactGA from "react-ga4";
import {ReadyToTravelComponent} from "../../components/tours/common/ReadyToTravelComponent";

const GeneralCountryComponent = ({title, children}) => {
    usePageTitle(title)
    const previousPage = sessionStorage.getItem("previousPage");

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: title })
    }, []);

    return (
        <Box sx={{padding: 0, display: 'flex', flexDirection: 'column'}}>
            {children}
            {previousPage != null && <BackButton/>}
            <Box sx={{
                pb:'60px',
            }}>
                <ReadyToTravelComponent/>
            </Box>
        </Box>
    );
};

const usePageTitle = (titleKey) => {
    const {t} = useLanguage();

    useEffect(() => {
        document.title = t(titleKey);
    }, [t, titleKey]);
};


export default GeneralCountryComponent;
